import { render } from "./Cell.vue?vue&type=template&id=6d781f84&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=6d781f84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kama484\\Monopoly\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d781f84"]])

export default __exports__